import { OTSM } from '../../@types/index.js'
import { useOneTimeServerMessage } from '../hooks/useOneTimeServerMessage.js'

export interface OtsmProps {
  otsm: OTSM
}

export const Otsm = ({ otsm }: OtsmProps) => {
  useOneTimeServerMessage(otsm)

  return null
}
